import { render, staticRenderFns } from "./SearchSetup.vue?vue&type=template&id=7a24d3e8&scoped=true&"
import script from "./SearchSetup.vue?vue&type=script&lang=js&"
export * from "./SearchSetup.vue?vue&type=script&lang=js&"
import style0 from "./SearchSetup.vue?vue&type=style&index=0&id=7a24d3e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a24d3e8",
  null
  
)

export default component.exports